import { useCallback } from "react";
import { useDispatch } from "react-redux";
import { useAppSelector } from "src/store";
import { usePlansApi } from "../api";
import { resetError, setError, setLoading } from "../slices";
import { CreateAdminPlanRequestData, UpdateAdminPlanRequestData } from "../types";

export const usePlanService = () => {
  const dispatch = useDispatch();
  const { loading, error } = useAppSelector((state) => state.plans);

  const api = usePlansApi();

  const createPlan = useCallback(async (data: CreateAdminPlanRequestData) => {
    try {
      dispatch(resetError());
      dispatch(setLoading({ create: true }));

      await api.createAdminPlan(data);
    } catch (e) {
      dispatch(setError(e));
      throw e;
    } finally {
      dispatch(setLoading({ create: false }));
    }
  }, []);

  const updatePlan = useCallback(async (planId: string, data: UpdateAdminPlanRequestData) => {
    try {
      dispatch(resetError());
      dispatch(setLoading({ update: true }));

      await api.updateAdminPlan(planId, data);
    } catch (e) {
      dispatch(setError(e));
      throw e;
    } finally {
      dispatch(setLoading({ update: false }));
    }
  }, []);

  const archivePlan = useCallback(async (planId: string) => {
    try {
      dispatch(resetError());
      dispatch(setLoading({ archive: true }));

      await api.archiveAdminPlan(planId);
    } catch (e) {
      dispatch(setError(e));
      throw e;
    } finally {
      dispatch(setLoading({ archive: false }));
    }
  }, []);

   const unarchivePlan = useCallback(async (planId: string) => {
    try {
      dispatch(resetError());
      dispatch(setLoading({ unarchive: true }));

      await api.unarchiveAdminPlan(planId);
    } catch (e) {
      dispatch(setError(e));
      throw e;
    } finally {
      dispatch(setLoading({ unarchive: false }));
    }
  }, []);

  return {
    loading,
    error,
    createPlan,
    updatePlan,
    archivePlan,
    unarchivePlan,
  };
};
